module.exports = __webpack_public_path__ + "img/icon-08_new.5c665312.svg";